// import React, { createContext, useReducer } from 'react'

// export const LangContext = createContext();

// const initialState = {
//     np: false,
//     npRender: 'data.en',
// }

// const LangReducer = (state, action) => {
//     switch (action.type) {
//         case "ENGLISH":
//             return { np: false, npRender: 'data.en' };
//         case "NEPALI":
//             return { np: true, npRender: 'data.np' };
//         default:
//             return state;
//     }
// };

// export function LangProvider(props) {
//     const [state, dispatch] = useReducer(LangReducer, initialState);

//     return <LangContext.Provider value={{ state, dispatch }}>{props.children}</LangContext.Provider>
// }

import React, { createContext, useReducer, useEffect } from "react";

export const LangContext = createContext();

const initialState = {
  np: false,
  npRender: "data.en",
};

// Get initial state from localStorage if available
const getInitialState = () => {
  const savedLang = localStorage.getItem("language");
  if (savedLang === "np") {
    return { np: true, npRender: "data.np" };
  } else {
    return { np: false, npRender: "data.en" };
  }
};

const LangReducer = (state, action) => {
  switch (action.type) {
    case "ENGLISH":
      localStorage.setItem("language", "en"); // Save to localStorage
      return { np: false, npRender: "data.en" };

    case "NEPALI":
      localStorage.setItem("language", "np"); // Save to localStorage
      return { np: true, npRender: "data.np" };

    default:
      return state;
  }
};

export function LangProvider({ children }) {
  const [state, dispatch] = useReducer(LangReducer, getInitialState());

  // Optional: If you want to sync state with localStorage on first load
  useEffect(() => {
    const savedLang = localStorage.getItem("language");
    if (savedLang === "np") {
      dispatch({ type: "NEPALI" });
    } else {
      dispatch({ type: "ENGLISH" });
    }
  }, []);

  return (
    <LangContext.Provider value={{ state, dispatch }}>
      {children}
    </LangContext.Provider>
  );
}
